// import $ from 'jquery';
import plugin from '../../plugins/lib';

const ELEMENT_SELECTOR = '[data-quote-cta-controller]';
const PLUGIN_NAME = 'quoteCtaController';
import module from './quote-cta';
$(document).ready(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		plugin(PLUGIN_NAME, module);
		$(element)[PLUGIN_NAME]();
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/quote-cta/index--split.js